import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

export default function TanggalSeleksi({ data }) {
  return (
    <section className="flex flex-col -md:pl-5 -md:mt-16">
      <div className="md:w-2/3 flex md:justify-end">
        <ScrollAnimation animateOnce={true} animateIn="fadeInLeft">
          <h1 className="md:text-6xl -md:text-lg text-yellow italic font-black -md:hidden">
            {data.title}
          </h1>
        </ScrollAnimation>
      </div>
      <div className="relative w-full md:mt-10 -md:mt-4">
        <img
          src={data.image}
          className="absolute right-0 -md:hidden"
          alt="timeline"
        />
        <img src={data.image2} className="right-0 md:hidden" alt="timeline" />
        {data.items.map((item, i) => (
          <div
            key={i}
            className={`${classList[i]} -md:hidden flex items-center ml-auto`}
          >
            <ScrollAnimation animateOnce={true} animateIn="fadeInRight">
              <div className="flex flex-col -md:mb-5">
                <h3 className="text-3xl -md:text-xs font-bold">{item.title}</h3>
                <p className="text-2xl -md:text-xs">{item.subtitle}</p>
              </div>
            </ScrollAnimation>
          </div>
        ))}
      </div>
    </section>
  );
}

export const classList = [
  "md:w-10/12 md:pl-6 md:h-60 -md:pt-8 -md:pl-10",
  "md:w-8/12 md:h-48 -md:pt-3 -md:pl-24",
  "md:w-6/12 md:h-40 -md:pt-2 -md:pl-44",
  "md:w-5/12 md:pl-20 md:h-48 -md:pt-3 -md:pl-56",
];
